import React from 'react';
import PropTypes from 'prop-types';

class IconSvg extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired
    };

    render() {
        const {id} = this.props;

        let className = this.props.className ? this.props.className + " icon-svg" : 'icon-svg';
        className += " icon-svg--" + id;

        return (
            <span className={className}>
                {
                <svg className="icon-svg__svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
		            <use xlinkHref={require("img/icons/" + id + '.svg')} x="0" y="0" width="100%" height="100%" />
	            </svg>
	            }
            </span>
        )
    }
}

export default IconSvg;


// WEBPACK FOOTER //
// ./src/components/IconSvg.jsx